import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent implements OnInit {
  token: string = '';
  password: string = '';
  confirmPassword: string = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private toastr: ToastrService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = this.activatedRoute.snapshot.paramMap.get('token') || '';
  }

  Submit() {
    var error = '';
    if (!this.password) {
      error = 'Enter New Password.';
    } else if (!this.confirmPassword) {
      error = 'Confirm Password Field is Required.';
    } else if (this.password != this.confirmPassword) {
      error = 'Password and Confirm Password must be same.';
    } else if (this.password.length < 8) {
      error = 'Password must be atleast 8 characters.';
    }
    if (error) {
      this.toastr.error(error);
    } else {
      var payload = {
        password: this.password,
        confirmPassword: this.confirmPassword,
      };
      this.authService.resetPassword(this.token, payload).subscribe((res) => {
        this.toastr.success('Your password has been reset.');
        this.router.navigate(['/login']);
      });
    }
  }
}
